import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import {
  addNonInventoryItem,
  updateNonInventoryItem,
  getNonInventoryItemById,
} from "../services/nonInventoryService";

const AddNonInventoryItemLayer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);

  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    description: "",
  });

  const [errors, setErrors] = useState({});

  /* ================= LOAD EDIT DATA ================= */
  useEffect(() => {
    if (isEdit) loadItem();
  }, [id]);

  const loadItem = async () => {
    try {
      const res = await getNonInventoryItemById(id);

      if (res?.status === "success") {
        const item = res.data;

        setForm({
          name: item.name ?? "",
          description: item.description ?? "",
        });
      } else {
        toast.error("Failed to load item");
      }
    } catch {
      toast.error("API Error");
    }
  };

  /* ================= CHANGE ================= */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  /* ================= VALIDATION ================= */
  const validate = () => {
    let temp = {};
    if (!form.name.trim()) temp.name = "Name is required";
    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      const res = isEdit
        ? await updateNonInventoryItem(id, form)
        : await addNonInventoryItem(form);

      if (res?.status === "success") {
        toast.success(isEdit ? "Updated successfully" : "Added successfully");
        navigate("/non-inventory-list");
      } else {
        toast.error(res?.message || "Failed");
      }
    } catch {
      toast.error("API Error");
    }
    setLoading(false);
  };

  return (
    <div className="container mt-3 mb-5">
      <div className="addoutlet-wrapper">
        <h4>{isEdit ? "Update" : "Add"} Non Inventory Item</h4>

        <form onSubmit={handleSubmit}>
          <div className="sf-field full">
            <label>Name *</label>
            <input
              className="addoutlet-input"
              name="name"
              value={form.name}
              onChange={handleChange}
            />
            {errors.name && (
              <p className="addoutlet-error">{errors.name}</p>
            )}
          </div>

          <div className="sf-field full">
            <label>Description</label>
            <textarea
              className="addoutlet-input"
              name="description"
              value={form.description}
              onChange={handleChange}
            />
          </div>

          <div className="d-flex gap-3 mt-4">
            <button disabled={loading} className="addoutlet-btn-primary">
              {loading ? "Saving..." : isEdit ? "Update" : "Add"}
            </button>

            <Link
              to="/non-inventory-list"
              className="addoutlet-btn-secondary"
            >
              Back
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddNonInventoryItemLayer;
